module.exports = __webpack_public_path__ + "img/yellow_lock.4840fb8e.png";